import { FC } from 'react';
import MainLayout from 'components/main-layout/MainLayout';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';

import API from 'core/Api';
import { updateUserData } from 'utils/userDataSync';
import { useWorkModeContext } from 'store/work-mode';
import { useLanguageContext } from 'store/language';
import ChangePasswordForm from './components/ChangePasswordForm';

const ProfileSettings: FC = () => {
  const { t } = useTranslation();
  const { setWorkMode, setWorkModeName, setAltWorkModeName } = useWorkModeContext();
  const { setLanguage } = useLanguageContext();
  const { isLoading, error, data } = useQuery('user', () =>
    updateUserData({
      setWorkMode,
      setWorkModeName,
      setAltWorkModeName,
      setLanguage,
    })
  );

  return (
    <MainLayout
      isLoading={isLoading}
      error={error}
      title={t('profile.title')}
    >
      <Row className="mb-4">
        <Col md={{ span: 10, offset: 2 }}>
          <h5>{t('profile.personalInfo')}</h5>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col
          xs={2}
          className="text-right"
        >
          {t('profile.name')}:
        </Col>
        <Col xs={10}>
          <b>{data && `${data.first_name} ${data.last_name}`}</b>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col
          xs={2}
          className="text-right"
        >
          E-mail:
        </Col>
        <Col xs={10}>
          <b>{data && data.email}</b>
        </Col>
      </Row>
      <hr />
      <ChangePasswordForm
        title={t('profile.changePassword')}
        email={data?.email || ''}
        request2FaCode={data?.two_fa_type || false}
      />
      <small className="form-text text-muted mt-4">
        {t('profile.feVersion')} {process.env.REACT_APP_VERSION}
      </small>
    </MainLayout>
  );
};

export default ProfileSettings;
